// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_h-0";
export var colorSwatch = "_h-5";
export var compactSwatch = "_h-7";
export var fillWidth = "_h-4";
export var iconButton = "_h-2";
export var iconWrapper = "_h-3";
export var shadow = "_h-6";
export var xs = "_h-1";